module.exports = __webpack_public_path__ + "static/images/pause.8798149.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit/config/pause.png
// module id = ul7W
// module chunks = 6 7